import React, { useState } from 'react';
import { Typography, Paper, TextField, Button, Grid, Box, Container } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const CreatePatientHistory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [patient] = useState({
        name: 'Juan Perez', // Simulación de datos del paciente
        sex: 'Masculino',
        age: 30,
        idNumber: id,
    });
    const [newEntry, setNewEntry] = useState({
        date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        clinicalHistory: '',
        diagnosis: '',
        treatment: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewEntry({ ...newEntry, [name]: value });
    };

    const handleSaveAndPrescription = () => {
        // Aquí añadiríamos la lógica para guardar la nueva historia clínica
        // Por ahora, redirigimos a una página de Receta
        navigate(`/prescription/${id}`);
    };

    return (
        <Container maxWidth="md" sx={{ marginTop: 4, height: '80vh', overflowY: 'auto' }}>
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
                <Typography variant="h4" gutterBottom align="center">Crear Historia Clínica</Typography>
                <Box sx={{ textAlign: 'center', marginBottom: 3 }}>
                    <Typography variant="h6">Paciente: {patient.name}</Typography>
                    <Typography variant="h6">Sexo: {patient.sex}</Typography>
                    <Typography variant="h6">Edad: {patient.age}</Typography>
                    <Typography variant="h6">Número de Identificación: {patient.idNumber}</Typography>
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField 
                            label="Fecha" 
                            variant="outlined" 
                            fullWidth 
                            margin="normal" 
                            name="date"
                            value={newEntry.date}
                            InputProps={{
                                readOnly: true,
                            }}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            label="Historia Clínica" 
                            variant="outlined" 
                            fullWidth 
                            margin="normal" 
                            name="clinicalHistory"
                            value={newEntry.clinicalHistory}
                            onChange={handleInputChange}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            label="Diagnóstico" 
                            variant="outlined" 
                            fullWidth 
                            margin="normal" 
                            name="diagnosis"
                            value={newEntry.diagnosis}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button 
                            variant="outlined" 
                            color="primary" 
                            fullWidth 
                            href="https://mediately.co/es/icd" 
                            target="_blank"
                            sx={{ marginBottom: 2 }}
                        >
                            CIE 10
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            label="Tratamiento" 
                            variant="outlined" 
                            fullWidth 
                            margin="normal" 
                            name="treatment"
                            value={newEntry.treatment}
                            onChange={handleInputChange}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            fullWidth 
                            onClick={handleSaveAndPrescription}
                        >
                            Receta
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default CreatePatientHistory;
